import styled from 'styled-components'

const TextInput = styled.input`
  border: 1px solid #ccc;
  font-size: 13px;
  padding: 15px 9px;

  ::placeholder {
    color: #ccc;
  }
`

export default TextInput
